import { useState } from 'react'

export const useLinkedin = () => {
  const [option, handleOption] = useState(false)
  const [isShowModal, setIsShowModal] = useState(false)

  return [handleOption, option, setIsShowModal, isShowModal]
}
